import { Show } from "solid-js"
import { Card } from "@opencode-ai/ui/card"
import { useI18n, type UiI18nKey } from "@opencode-ai/ui/context/i18n"
import { BasicTool } from "./basic-tool"

export function businessToolLabel(tool: string, enabled: boolean): UiI18nKey | undefined {
  if (!enabled) return
  switch (tool) {
    case "read":
      return "ui.tool.reviewingInformation"
    case "list":
    case "glob":
    case "grep":
      return "ui.tool.findingInformation"
    case "edit":
    case "write":
    case "patch":
    case "apply_patch":
      return "ui.tool.preparingAnalysis"
    case "bash":
    case "shell":
      return "ui.tool.processingData"
    case "skill":
      return "ui.tool.loadingAgentSkills"
  }
}

// Only presentation-safe values cross this boundary, never tool input/output or errors.
export function BusinessToolActivity(props: { label: UiI18nKey; status?: string }) {
  const i18n = useI18n()
  return (
    <div data-component="business-tool-activity" data-status={props.status}>
      <Show
        when={props.status === "error"}
        fallback={<BasicTool icon="task" status={props.status} hideDetails trigger={{ title: i18n.t(props.label) }} />}
      >
        <div role="alert">
          <Card variant="error">
            <div>{i18n.t(props.label)}</div>
            <div>{i18n.t("ui.tool.stepFailed")}</div>
          </Card>
        </div>
      </Show>
    </div>
  )
}
